"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchField = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
exports.SearchField = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  font-size: 15px;\n  height: 46px;\n  left: ", ";\n  margin-bottom: 0;\n  padding: 14px 32px 14px 16px;\n  position: absolute;\n  top: ", ";\n  width: ", ";\n  z-index: 1;\n\n  &::placeholder {\n      color: ", ";\n  }\n\n  &:focus, &:active {\n    outline: none;\n  }\n"], ["\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  font-size: 15px;\n  height: 46px;\n  left: ", ";\n  margin-bottom: 0;\n  padding: 14px 32px 14px 16px;\n  position: absolute;\n  top: ", ";\n  width: ", ";\n  z-index: 1;\n\n  &::placeholder {\n      color: ", ";\n  }\n\n  &:focus, &:active {\n    outline: none;\n  }\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var search = _a.search;
    return search ? ' 30px' : '1px';
}, function (_a) {
    var visible = _a.visible;
    return visible ? '1px' : '-10000px';
}, function (_a) {
    var search = _a.search;
    return search ? 'calc(100% - 65px) !important' : 'calc(100% - 25px) !important';
}, function (_a) {
    var placeholderColor = _a.placeholderColor, theme = _a.theme;
    return utils_1.parseThemePath(placeholderColor, theme, colors_1.colors.GREY_650);
});
var templateObject_1;
//# sourceMappingURL=SearchField.js.map